import { SeuCalculationResponseItem } from '@seu-types';

/**
 * Checks if a calculation result is exportable (has success, warning, or critical status).
 * Only calculations with error status are not exportable.
 */
export function isCalculationExportable(
  item: SeuCalculationResponseItem
): boolean {
  return (
    item.computationState === 'success' ||
    item.computationState === 'warning' ||
    item.computationState === 'critical'
  );
}
